<template>
  <section>
    
    <b-navbar toggleable="false" type="light" class="navbar-expand topheader" v-bind:class="{ 'd-block d-md-none loggedin': loggedIn }">
      <b-navbar-nav  v-if="loggedIn">
        <b-nav-item @click="toggleLeftbar">
          <i class="fa fa-bars nav-icon" />
        </b-nav-item>

         <b-dropdown v-if="1 == 0" v-b-tooltip.hover title="Notifications" variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fal fa-bell nav-icon" />
            <span class="badge badge-icon">{{ user.notificationsTotal }}</span>
          </template>
           <b-dropdown-header id="dropdown-header-label">
              Notifications
            </b-dropdown-header>
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :to="{ name: 'Documents.Public' }" class="text-center small">View all</b-dropdown-item>
        </b-dropdown>

      </b-navbar-nav>
      <b-navbar-nav v-if="!user">
        
        <b-nav-item :to="{ name: 'Login' }">
          <img src="/img/logo.png" style="height: 40px" />
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto" v-if="!loggedIn">
        <b-nav-item @click="showDcpnDescription">{{$t('WHAT_IS_DCPN')}}</b-nav-item>
        <b-nav-item :href="loginUrl">{{$t('LOGIN.TITLE')}}</b-nav-item>
        
      </b-navbar-nav>
    </b-navbar>


    <b-modal size="lg" v-model="dcpnDescription" :title="$t('WHAT_IS_DCPN')" ok-only>

      <div class="mt-2">
        
        <p>What DCPN offers is an innovative way to provide a digital trackable system that provides non-repudiation over what policies, agreements and other documents were valid at a specific time.</p>
        <p>By publishing a document in DCPN’s repository <strong>a unique digital identity of the specific document is created</strong>. The systems create a trackable audit trail, providing non-repudiation, to define exactly what document what published at what time. When combining this with system for electronic signatures such as a national eID a completely new robust and legally enforceable product is created.</p>
        <p>When using DCPN’s <strong>CMP Software</strong>, Create Manage and Publish Software, you have a tool to manage and get control of all your documents and policies.</p>

      </div>
    </b-modal>

  </section>
</template>

<script>

export default {
  data() {
    return {
      dcpnDescription: false,
      user: this.$store.state.auth.user
    };
  },
  methods: {    
    showDcpnDescription(){
      this.dcpnDescription = true;
    },
    toggleLeftbar() {
        this.$store.dispatch('sidebar/toggleLeft');
    },
    logoutAction() {
      this.$http
        .get(process.env.VUE_APP_BACKEND + `/auth/logout`)
        .finally(function() {
          this.$router.push("logout");
        });
    }
  },
  computed: {
    loggedIn() {      
      return this.$store.state.auth.user;
    },
    loginUrl() {
      return "/login?redirect=" + this.$router.history.current.path;
    }
  }
};
</script>
<style>
</style>